import { forwardRef } from 'react';
import styled from 'styled-components';
import { applySX, type WithSX } from '@elfsight/lib-utils';
import {
  WidgetBackground as LibWidgetBackground,
  type WidgetBackgroundProps
} from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { colors } from '../../constants';
import { getBackground } from '../../utils';

const { darkBlack01 } = colors;

export const WidgetBackground = forwardRef<
  HTMLDivElement,
  Partial<WidgetBackgroundProps>
>(({ children, borderRadius, ...forwardingProps }, ref) => {
  const {
    theme: {
      themeSettings: { background, timerColor }
    },
    renderThumbnailMode = false
  } = useSettings();

  const derivedBackground = getBackground({
    background,
    timerColor,
    withoutTransparent: renderThumbnailMode
  });

  return (
    <StyledLibWidgetBackground
      ref={ref}
      className={createReadableClass({ component: 'widget-background' })}
      borderRadius={borderRadius}
      $sx={{
        boxShadow: renderThumbnailMode ? `0 0 30px 0 ${darkBlack01}` : undefined
      }}
      {...derivedBackground}
      {...forwardingProps}
    >
      {children}
    </StyledLibWidgetBackground>
  );
});

const StyledLibWidgetBackground = styled(LibWidgetBackground)<WithSX>`
  ${applySX}
`;
